module.exports = __webpack_public_path__ + "img/fail.7723cdb4.png";